import { Form } from "antd"
import PasswordChangeForm from "../../authentication/PasswordChangeForm"
import { changePasswordAsync } from "../../../../app/store/reducers/auth/authReducer"




const ChangePassword = () => {
    const [form] = Form.useForm()
    // const initialValues = {
    //     oldPassword: "Hello",
    //     newPassword: "Test"
    // }


    const onSubmit = async (values) => {
        console.log("values", values)

        await changePasswordAsync({
            oldPassword: values?.oldPassword,
            newPassword: values?.newPassword
        })
        .then((response) => {
            console.log(response);
        })
        .catch((error) => {
            console.log(error);
        })
    }


    return (
    <>
        <Form
            form={form}
            // initialValues={initialValues}
            name="control-hooks"
            layout="vertical"
            onFinish={onSubmit}
        >
            <PasswordChangeForm/>
        </Form>
    </>
  )
}

export default ChangePassword